import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import { AuthorizationService } from "@core/services/authorization.service";
import { ClaimColumnName } from "@helper/types/claim";
import { PaymentsColumnName } from "@helper/types/payment";
import { UsersColumnName } from "@helper/types/user";
import { Store } from "@ngxs/store";
import * as ClaimActions from "../../layout/claims/claims.actions";
import * as PaymentsActions from "../../layout/payments/payments.actions";
import * as UsersActions from "../../layout/users/state/users.actions";
import { ConfigurationFormBuilderService } from "./configuration-form-builder.service";

@Component({
	selector: "app-configuration",
	templateUrl: "./configuration.component.html",
	styleUrls: ["./configuration.component.scss"]
})
export class ConfigurationComponent implements OnInit, OnDestroy {
	@Input() public page: "claims" | "payments" | "users";
	public form: UntypedFormGroup;
	public isConfigurationOpen = false;
	public dropdownStyles: { [key: string]: string } = {};
	private unsubscribe$$ = new Subject<void>();

	constructor(
		configurationFormBuilderService: ConfigurationFormBuilderService,
		private store: Store,
		public authorizationService: AuthorizationService
	) {
		this.form = configurationFormBuilderService.getForm();
	}

	public ngOnInit(): void {
		this.form.valueChanges
			.pipe(takeUntil(this.unsubscribe$$))
			.subscribe(() => {
				this.dispatchStoreActions();
			});
	}

	// tslint:disable:no-any
	public isLastFieldTrue(obj: any, fieldName: string): boolean {
		const fieldsTrue = Object.entries(obj).filter(value => value[1] === true);
		return fieldsTrue.length === 1 && fieldsTrue[0][0] === fieldName;
	}

	public toggleConfigurationFields(event: MouseEvent): void {
		event.stopPropagation();
		this.isConfigurationOpen = !this.isConfigurationOpen;
		if (this.isConfigurationOpen) {
			const button = event.currentTarget as HTMLElement;
			const rect = button.getBoundingClientRect();

			this.dropdownStyles = {
				position: "fixed",
				top: `${rect.bottom}px`,
				left: `${rect.left}px`,
				zIndex: "99"
			};
		}
	}

	private dispatchStoreActions(): void {
		const claimsColumnsFormGroupValue = this.form.getRawValue().claimColumns;
		this.store.dispatch(new ClaimActions.SetColumns(
			Object.keys(claimsColumnsFormGroupValue).filter(key => claimsColumnsFormGroupValue[key]) as ClaimColumnName[]
		));

		const paymentsColumnsFormGroupValue = this.form.getRawValue().paymentsColumns;
		this.store.dispatch(new PaymentsActions.SetColumns(
			Object.keys(paymentsColumnsFormGroupValue).filter(key => paymentsColumnsFormGroupValue[key]) as PaymentsColumnName[]
		));

		if (this.authorizationService.isSuper) {
			const usersColumnsFormValue = this.form.getRawValue().usersColumns;
			this.store.dispatch(new UsersActions.SetColumns(
				Object.keys(usersColumnsFormValue).filter(key => usersColumnsFormValue[key]) as UsersColumnName[]
			));
		}
	}

	public ngOnDestroy(): void {
		this.unsubscribe$$.next();
		this.unsubscribe$$.complete();
	}
}
